import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Co2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"co2"}/>
}
